import { localStorageTest } from "./localStorageTest.js";
/**
 * Saves the JWT token in localStorage or `window.%s` fallback.
 */ function persistJwtToken(localStorageName, jwt) {
    if (localStorageTest()) {
        if (jwt) {
            localStorage.setItem(localStorageName, jwt);
        } else {
            localStorage.removeItem(localStorageName);
        }
    } else {
        if (jwt) {
            window[localStorageName] = jwt;
        } else {
            delete window[localStorageName];
        }
    }
}
export { persistJwtToken };
